import { useSelector } from 'react-redux';

import { selectProductsFindMeLastClickTime } from '@lib/tools/clickTracker/selectors/clickTracker';
import { recordClickTime } from '@lib/tools/clickTracker/slice/clickTracker';
import { useTypedDispatch } from '@lib/tools/views/hooks';

export const useClickTracker = () => {
  const dispatch = useTypedDispatch();
  const productsFindMeLastClickTime = useSelector(selectProductsFindMeLastClickTime);

  const handleRecordClickTime = ({
    id,
    now,
    clickType,
    isClicked,
  }: {
    id: string;
    now: number;
    clickType: string;
    isClicked: boolean;
  }) => {
    if (!isClicked) {
      dispatch(recordClickTime({ clickType, id, timestamp: now }));
    }
  };

  return {
    handleRecordClickTime,
    productsFindMeLastClickTime,
  };
};
